import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { TEXT_SIZE_XSMALL } from 'components/Txt';
import { useConfirm } from 'hooks/useConfirm';
import { theme } from 'lib/theme';
import * as React from 'react';

interface Props {
  fieldLabel: string;
  onClearAndHide: () => void;
}

export const FieldShouldBeHidden: React.FC<Props> = ({
  onClearAndHide,
  fieldLabel,
}) => {
  const confirm = useConfirm();
  return (
    <CardRow
      icon={ICONS.TrashCanLight}
      iconColor={theme.colors.red}
      onPress={onClearAndHide}
      label="Clear and hide this field..."
      labelColor={theme.colors.red}
      iconSize={15}
      labelStyle={{ fontSize: TEXT_SIZE_XSMALL }}
      style={{ minHeight: undefined }}
      actionIcon={ICONS.CircleInfoLight}
      onAction={() =>
        confirm({
          title: 'Clear and Hide Field',
          text:
            `"${fieldLabel}" ` +
            'should be hidden because of a value in another field.\n\n' +
            'Clear this field to hide it.',
          confirmText: 'Clear',
          confirmIcon: ICONS.TrashCanLight,
          cancelText: 'Keep Value',
          destructive: true,
          onConfirm: onClearAndHide,
        })
      }
    />
  );
};
